//#region Libraries
import styled from "styled-components";
//#endregion

export const Content = styled.section`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;
export const FieldsGroup = styled.section`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: ${({ width = "280px" }) => width};
    & > *:nth-child(2) {
        width: 100%;
    }
`;